const validatePresentation = async(payload) => {
    const { presentation, ...data } = payload

    try {
        return await axios.post(`curriculum/presentation/${presentation}/validate`, data)
    } catch(e) {
        throw e
    }
}

const validatePresentationByResearchCommittee = async(payload) => {
    const { presentation, ...data } = payload
    
    try {
        return await axios.post(`curriculum/presentation/research-committee/${presentation}/validate`, data)
    } catch(e) {
        throw e
    }
}

const deletePresentation = async(payload) => {
    const { presentation, ...data } = payload
    
    try {
        return await axios.delete(`curriculum/presentation/${presentation}/delete`,{
            data: data,
        })
    } catch(e) {
        throw e
    }
}

export {
    validatePresentation,
    validatePresentationByResearchCommittee,
    deletePresentation,
}